import { render, staticRenderFns } from "./ModalFotoProdutoAlmoxarifado.vue?vue&type=template&id=1ab8146f"
import script from "./ModalFotoProdutoAlmoxarifado.vue?vue&type=script&lang=js"
export * from "./ModalFotoProdutoAlmoxarifado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports